<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">institution</th>
                <th class="table-heading-text text-center">type</th>
                <th class="table-heading-text text-center">identifier</th>
                <th class="table-heading-text text-center">balance</th>
                <th class="table-heading-text text-center">interest rate</th>
                <th class="table-heading-text text-right">annual interest</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="loan in loans.private_loans" :key="loan.id" @click="showEditModal(loan )">
                <td class="table-content-text text-left"> {{ loan.institution }}</td>
                <td class="table-content-text">{{ loan.loan_type }}</td>
                <td class="table-content-text">{{ loan.identifier }}</td>
                <td class="table-content-text">{{ loan.balance.toLocaleString() }}</td>
                <td class="table-content-text">{{ Number(loan.interest_rate).toLocaleString('en-GB', { style: 'percent', minimumFractionDigits:2 }) }}</td>
                <td class="table-content-text text-right">{{ Number(loan.annual_interest).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td></td>
                <td></td>
                <td class="table-heading-text">{{ Number(loans.total_balance).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
                <td class="table-heading-text">{{ Number(loans.total_interest_rate).toLocaleString('en-GB', { style: 'percent', minimumFractionDigits:2 }) }}</td>
                <td class="table-heading-text text-right">{{ Number(loans.total_annual_interest).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <!-- Modals -->
  <LoansModalPopup :show="showModal" @close="showModal = false"></LoansModalPopup><!-- add a new record -->
  <LoansEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></LoansEditModalPopup> <!-- edit a record -->

</template>

<script>
import axios from 'axios';
import LoansModalPopup from './modals/LoansNewModalPopup.vue';
import LoansEditModalPopup from './modals/LoansEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    LoansModalPopup,
    LoansEditModalPopup
  },
  data() {
    return {
      loans: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {}
    };
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'private loans',
          disabled: true,
          href: ''
        },
      ];
    },

  },
  async created() {
    this.getPrivateLoans();
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
      this.selectedRow=row;
      this.showEditModalToggle = true;
    },
    async getPrivateLoans(){
      try {
      const response  = await axios.get("/privateloans/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
      this.loans = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load loans' });
      }
    }
  }
  
};

</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

</style>